module.exports = "<div class=\"top panel\">\n    <baf-header></baf-header>\n</div>\n\n<div class=\"center panel\">\n    <baf-error-view *ngIf=\"!isValidState\"></baf-error-view>\n    <baf-main-view></baf-main-view>\n    <baf-dialogs></baf-dialogs>\n    <baf-loading></baf-loading>\n</div>\n\n<div class=\"bottom panel\">\n    <baf-footer></baf-footer>\n</div>\n\n<ng-template #template></ng-template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/layout/layout.component.html
// module id = ./src/app/components/layout/layout.component.html
// module chunks = main